<template>
    <div class="campaign_info slightly_yellow_background center_text card">
      <div
        class="flex justify_center relative"
      >
        <icon campaign xlarge class="mxa"/>
        <div
          :style="`background-color: ${statusObj.color};`"
          class="mya status-tag"
        >{{ statusObj.text }}</div>
      </div>

      <h2 class="medium heading" style="margin: 0">{{ infoTitle }}</h2>

      <p v-if="isNew" class="subheading mt2">
        <i>{{ $t('cms.campaign.NewCampaignText') }}</i>
      </p>

      <p v-else class="pb0 subheading mt2 mb3">
          {{ $t('cms.campaign.StartedOn') }} {{ startDateText }} {{ $t('cms.campaign.At') }} {{campaign.startTime}}<br/>
          {{ $t('cms.campaign.EndsOn') }} {{ endDateText }} {{ $t('cms.campaign.At') }} {{campaign.endTime}}<br/>
          {{ $t('cms.campaign.Repeats') }} {{ `${campaignRepeatsText[0].toLowerCase()}${campaignRepeatsText.slice(1)}` }}
      </p>
    </div>
</template>

<script>
export default {
  props: ['startDateText', 'endDateText', 'campaignRepeatsText', 'campaign', 'number', 'isNew', 'status'],
  computed: {
    statusObj() {
      return this.$CONSTANTS.campaignStatusTypes[this.status] || {};
    },
    infoTitle() {
      return this.isNew
        ? this.$t('cms.campaign.NewCampaignLabel')
        : ` ${this.$t('cms.campaign.CampaignTicketNumber')} ${this.number + 1}/7`;
    },
  },
};
</script>

<style lang="scss" scoped>
.status-tag {
    position: absolute;
    top: 0;
    right: 0;
    color: black;
    font-weight: 700;
    padding: 4px 12px;
    border-radius: $border_radius;
    border: solid 1px black;
  }
</style>
